import * as React from 'react';
import { useDeviceType, TDeviceType } from '@cian/ui-kit';

export interface IWithDeviceTypeProps {
  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  deviceType: TDeviceType;
}

/**
 * HOC для передачи в компонент знания о текущем типе устройства.
 *
 * @see https://react-typescript-cheatsheet.netlify.app/docs/hoc/full_example/.
 */
export function withDeviceType<T extends IWithDeviceTypeProps = IWithDeviceTypeProps>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<T>>,
) {
  /* istanbul ignore next */
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithDeviceType = (props: Omit<T, keyof IWithDeviceTypeProps>) => {
    const deviceType = useDeviceType();

    return (
      <WrappedComponent
        {...(props as T)}
        isPhone={deviceType === 'phone'}
        isTablet={deviceType === 'tablet'}
        isDesktop={deviceType === 'desktop'}
        deviceType={deviceType}
      />
    );
  };

  ComponentWithDeviceType.displayName = `withDeviceType(${displayName})`;

  return ComponentWithDeviceType;
}
